var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "88.008125%",
    x2: "79.3721548%",
    y2: "10.6570508%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/vacation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,144 C99.313,144 102,146.687 102,150 L102,170 C102,173.313 99.313,176 96,176 C92.687,176 90,173.313 90,170 L90,150 C90,146.687 92.687,144 96,144 Z M138.4262,129.9412 L152.5682,144.0842 C154.9122,146.4272 154.9122,150.2252 152.5682,152.5682 C151.3972,153.7402 149.8612,154.3262 148.3262,154.3262 C146.7912,154.3262 145.2552,153.7402 144.0842,152.5682 L129.9412,138.4262 C127.5972,136.0832 127.5972,132.2842 129.9412,129.9412 C132.2832,127.5972 136.0842,127.5972 138.4262,129.9412 Z M62.0583,129.9402 C64.4023,132.2842 64.4023,136.0832 62.0593,138.4262 L47.9173,152.5682 C46.7453,153.7402 45.2103,154.3262 43.6743,154.3262 C42.1383,154.3262 40.6033,153.7402 39.4313,152.5692 C37.0883,150.2252 37.0883,146.4272 39.4313,144.0842 L53.5733,129.9412 C55.9163,127.5972 59.7163,127.5982 62.0583,129.9402 Z M96,60 C115.882,60 132,76.118 132,96 C132,115.882 115.882,132 96,132 C76.118,132 60,115.882 60,96 C60,76.118 76.118,60 96,60 Z M96,72 C82.767,72 72,82.767 72,96 C72,109.233 82.767,120 96,120 C109.233,120 120,109.233 120,96 C120,82.767 109.233,72 96,72 Z M170,90 C173.313,90 176,92.687 176,96 C176,99.313 173.313,102 170,102 L150,102 C146.687,102 144,99.313 144,96 C144,92.687 146.687,90 150,90 L170,90 Z M42,90 C45.313,90 48,92.687 48,96 C48,99.313 45.313,102 42,102 L22,102 C18.687,102 16,99.313 16,96 C16,92.687 18.687,90 22,90 L42,90 Z M47.9174,39.4314 L62.0584,53.5734 C64.4024,55.9174 64.4024,59.7154 62.0584,62.0584 C60.8874,63.2304 59.3524,63.8164 57.8164,63.8164 C56.2804,63.8164 54.7454,63.2304 53.5734,62.0584 L39.4314,47.9174 C37.0884,45.5734 37.0884,41.7744 39.4314,39.4314 C41.7744,37.0884 45.5744,37.0884 47.9174,39.4314 Z M152.5696,39.4314 C154.9126,41.7744 154.9126,45.5734 152.5686,47.9174 L138.4256,62.0594 C137.2546,63.2304 135.7186,63.8164 134.1836,63.8164 C132.6476,63.8164 131.1126,63.2304 129.9406,62.0584 C127.5976,59.7154 127.5976,55.9174 129.9416,53.5734 L144.0836,39.4314 C146.4266,37.0874 150.2266,37.0894 152.5696,39.4314 Z M96,16 C99.313,16 102,18.687 102,22 L102,42 C102,45.313 99.313,48 96,48 C92.687,48 90,45.313 90,42 L90,22 C90,18.687 92.687,16 96,16 Z",
    id: "Logo",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacation);
export default __webpack_public_path__ + "f7a0c20b207db669d9c6fbccd2b2e1bb.svg";
export { ForwardRef as ReactComponent };